/** @format */

import "./index.css";

export function Header() {
  return (
    <>
      <header>
        <ol>
          <li>Devesh Vishnoi</li>
        </ol>
      </header>
    </>
  );
}
